export const getNotificationTrayOpenState = (state) => state.notificationTray.isOpen

export function getUnreadNotificationCount(state, props) {
  if (state.notificationTray.notifications && state.notificationTray.lastFetch) {
    return state.notificationTray.notifications.length
  } else {
    return props.notificationCount
  }
}
